import { Box } from "@baseline/ui/common";
import { useService } from "@baseline/ui/react";
import { View, Viewer } from "@baseline/ui/views";
import React, { FC } from "react";
import { ViewManager } from "../../ui";
import { styles } from "./app-screen.scss";
import { CardDropIn } from "./card-drop-in";


export const AppScreen: FC =
    () => {
        console.log("hifi")
        const viewManager = useService(ViewManager);
        const { views } = viewManager;

        return (
            <Box className={styles.appScreen}>

                {/* Main View */}
                <Viewer>
                    <View view={views.landingPage}>
                        <CardDropIn />
                    </View>
                </Viewer>

                {/* Modals */}
                {/* <ConfirmationPanel /> */}

                {/* Notifications */}
                {/* <Notifications /> */}
            </Box>
        );
    };
